// extracted by mini-css-extract-plugin
export default {"card":"CounterStepper_card__lHavq","stepButton":"CounterStepper_stepButton__63lge","valueStack":"CounterStepper_valueStack__ISuVv"};